import React, { useEffect, useState } from 'react'
import { Card } from '../../../components/Card'
import { TopSection } from '../../../components/TopSection'
import { Button } from '../../../components/Button'
import { CardType } from '../Step4'

import styles from './Step5.module.scss'
import { useIntl } from 'react-intl'
import FormattedMessage from '../../../helpers/FormattedMessage'
import { Prompt } from '../../../components/Prompt'

interface IProps {
  nextStep: () => void
  newProduct: () => void
  setPage: (page: number) => void
}

export const Step5 = ({ nextStep, newProduct, setPage }: IProps) => {
  const intl = useIntl()
  const [savedItems, setSavedItems] = useState(JSON.parse(window.localStorage.getItem('School-savedItems') || '[]'))
  const [removeIndex, setRemoveIndex] = useState(-1)

  useEffect(() => {
    window.localStorage.setItem('School-step', '5')
    window.localStorage.removeItem('School-noLogoPrompt')
  }, [])
  const removeItem = (index: number) => {
    setRemoveIndex(index)
  }

  const closePrompt = () => {
    setRemoveIndex(-1)
  }

  const remove = () => {
    const newArr = [...savedItems]
    newArr.splice(removeIndex, 1)
    setSavedItems(newArr)
    window.localStorage.setItem('School-savedItems', JSON.stringify(newArr))
    setRemoveIndex(-1)
  }

  const editItem = (index: number) => {
    window.localStorage.setItem('School-editItem', `${index}`)
    nextStep()
  }

  const complete = () => {
    setPage(7)
  }

  return (
    <>
      <TopSection
        title="SchoolShop.ProductsOverview.title"
        description="SchoolShop.ProductsOverview.text"
      />
      <div className={styles.Wrapper}>
        <Card>
          <div className={styles.Center}>
            <Button
              onClick={newProduct}
              buttonDescription='SchoolShop.ProductsOverview.addNew'
              buttonColor
              classWidth
            />
          </div>
        </Card>
        <div className={styles.ProductsOverviewCardTitle}>
          <h3><FormattedMessage id="SchoolShop.ProductsOverviewCard.title"/></h3>
        </div>
        {savedItems.map((item: CardType, index: number) => (
          <Card
            title={`ClothType.${item.clothType}`}
            onClose={() => {
              removeItem(index)
            }}
            onEdit={() => { editItem(index) }}
            hideContent
            key={index}
          >
            <div className={styles.List}>
              <div className={styles.Row}>
                <div>
                  <FormattedMessage id="Overview.props.color"/>:
                </div>
                <span><FormattedMessage id={`Color.${item.color}`}/></span>
              </div>
              <div className={styles.Row}>
                <div>
                  <FormattedMessage id="Overview.props.design"/>:
                </div>
                <span><FormattedMessage id={`Design.${item.design}`}/></span>
              </div>
              <div className={styles.Row}>
                <div>
                  <FormattedMessage id="Overview.props.logo"/>:
                </div>
                <span className={!item.logos.length ? styles.NoLogo : ''}>
                  {
                    item.logos?.length ?
                      item.logos.map((item, index) => item.name).join(', ')
                      : <FormattedMessage id="Overview.props.noLogo"/>
                  }
                </span>
              </div>
              <div className={styles.Row}>
                <div>
                  <FormattedMessage id="Overview.props.logoColor"/>:
                </div>
                <span><FormattedMessage id={item.otherLogoColor ? item.logoColor : `Color.${item.logoColor}`}/></span>
              </div>
              <div className={styles.Row}>
                <div>
                  <FormattedMessage id="Overview.props.priceBoost"/>:
                </div>
                <span><FormattedMessage id={`priceMargin.${item.priceMargin}`}/></span>
              </div>
            </div>
          </Card>
        ))}
      </div>
      <div className={`${styles.Center} ${styles.BottomMargin}`}>
        <Button
          onClick={complete}
          buttonDescription="completeShop"
          disabled={savedItems.length === 0}
          classWidth
          center
        />
      </div>
      {removeIndex >= 0 &&
        <Prompt
            componentTitle={
              <FormattedMessage
                id="Overview.removePrompt.title"
                values={{ product: intl.formatMessage({ id: `ClothType.${savedItems[removeIndex].clothType}` }) }}
              />
            }
            componentText={
              <FormattedMessage
                id="Overview.removePrompt.text"
                values={{ product: intl.formatMessage({ id: `ClothType.${savedItems[removeIndex].clothType}` }) }}
              />
            }
            cancel={closePrompt}
            submit={remove}
            submitText="remove"
            warning
        />
      }
    </>
  )
}
